
/**
 * Convert javascript object to formdata
 * @param obj
 * @param form
 * @param namespace
 */
export function objectToFormData(obj: Object, form?: FormData, namespace?: any) {

  // Create fromData from args if available
  const formData = form || new FormData()

  console.log('Object to form data', obj)

  for (let prop in obj) {

    // Remove undefined values
    if (obj[prop] === undefined) {
      delete obj[prop];
    }

    if (obj.hasOwnProperty(prop) && (obj[prop] !== null || obj[prop] !== undefined)) {

      let formKey = prop
      if (namespace) formKey = namespace + '[' + prop + ']'

      // if the property is an object, but not a File, use recursivity.
      if (typeof obj[prop] === 'object' && !(obj[prop] instanceof File)) {

        objectToFormData(obj[prop], formData, prop)

      }
      else if (typeof obj[prop] === 'boolean') {
        const val = obj[prop] ? 1 : 0
        formData.append(formKey, `${val}`)
      }

      else {
        // if it's a string or a File object
        formData.append(formKey, obj[prop])
      }

    }

  }

  return formData

}


/**
 * Removes null value field from the payload
 * @param obj
 * @returns obj
 */
export function removeNullFieldFromPaylod(payload: Object) {
  for (let prop in payload) {
    if (payload[prop] === null || payload[prop] === undefined) {
      delete payload[prop];
    }
  }

  return payload;
}

